import {
  EMBARGO_MODES,
  buildEmbargoFormContext,
  validateEmbargo,
  EMBARGO_PROCESS_RULES,
} from '../../../Pickups/PickupManagement/Embargo';
import type {
  EmbargoConfig,
  EmbargoValidationContext,
  EmbargoValidationResult,
} from '../../../Pickups/PickupManagement/Embargo/types';
import appConstants from '@appConstants';

type ProcessShipmentBillLike = {
  shipmentId?: string;
  pickupStatus?: string | null;
  editInfo?: {
    consigneeZip?: string | null;
    consigneeCity?: string | null;
    consigneeState?: string | null;
    consigneeCode?: string | null;
    isFreezable?: boolean | null;
  } | null;
};

type MapProcessPickupEmbargoContextOptions = {
  editBillsDataArray: ProcessShipmentBillLike[] | null | undefined;
  /** Id of the PRO being edited now. Other already-completed PROs are still skipped; only this one is checked again. */
  activeShipmentId?: string | null;
};

const isEmbargoEligibleProcessShipment = (
  bill: ProcessShipmentBillLike,
  activeShipmentId?: string | null
): boolean => {
  const isIncomplete = bill.pickupStatus !== appConstants.PICKUP_STATUS.COMPLETED;
  const isActiveShipment = Boolean(activeShipmentId) && bill.shipmentId === activeShipmentId;
  return isIncomplete || isActiveShipment;
};

export const mapProcessPickupEmbargoContext = ({
  editBillsDataArray,
  activeShipmentId,
}: MapProcessPickupEmbargoContextOptions): EmbargoValidationContext =>
  buildEmbargoFormContext({
    mode: EMBARGO_MODES.PROCESS,
    shipments: (editBillsDataArray ?? [])
      .filter((bill) => isEmbargoEligibleProcessShipment(bill, activeShipmentId))
      .map((bill) => ({
        pickupShipmentRowId: bill.shipmentId,
        destinationZip: bill.editInfo?.consigneeZip,
        destinationCity: bill.editInfo?.consigneeCity,
        destinationState: bill.editInfo?.consigneeState,
        consigneeCode: bill.editInfo?.consigneeCode,
        isFreezable: bill.editInfo?.isFreezable,
      })),
  });

export const evaluateProcessPickupEmbargo = ({
  editBillsDataArray,
  embargoConfig,
  activeShipmentId,
}: MapProcessPickupEmbargoContextOptions & {
  embargoConfig: EmbargoConfig;
}): EmbargoValidationResult => {
  const context = mapProcessPickupEmbargoContext({ editBillsDataArray, activeShipmentId });
  return validateEmbargo({ context, config: embargoConfig, rules: EMBARGO_PROCESS_RULES });
};
